import { Link } from 'react-router-dom';
import type { GameMeta } from '@/data/games';
import { useRewardStore } from '@/store/rewardStore';

/** Spiel-Karte im Auswahl-Grid — zeigt Sterne/Pokale falls vorhanden */
export default function GameCard({ game }: { game: GameMeta }) {
  const progress = useRewardStore((s) => s.progress[game.id]);

  return (
    <div
      className="rounded-2xl bg-white p-6 shadow-lg transition hover:scale-105 hover:shadow-xl dark:bg-gray-700"
      data-testid={`game-card-${game.id}`}
    >
      <div className="mb-3 text-5xl">{game.icon}</div>
      <h2 className="mb-2 text-xl font-bold text-gray-800 dark:text-gray-100">{game.title}</h2>
      <p className="mb-4 text-sm text-gray-600 dark:text-gray-300">{game.description}</p>

      {/* Reward-Anzeige */}
      {progress && (progress.totalStars > 0 || progress.roundsWon > 0) && (
        <div className="mb-4 flex gap-3 text-sm text-gray-500 dark:text-gray-400">
          {progress.totalStars > 0 && <span>⭐ {progress.totalStars}</span>}
          {progress.roundsWon > 0 && <span>🏆 {progress.roundsWon}</span>}
          {progress.highScore > 0 && <span>Best: {progress.highScore}</span>}
        </div>
      )}

      {game.available ? (
        <Link
          to={`/games/${game.id}`}
          className="block w-full rounded-xl bg-indigo-500 py-3 text-center font-semibold text-white transition hover:bg-indigo-600"
        >
          Spielen
        </Link>
      ) : (
        <span
          className="block w-full rounded-xl bg-gray-200 py-3 text-center font-semibold text-gray-400 dark:bg-gray-600 dark:text-gray-500"
          aria-disabled="true"
        >
          Bald verfügbar
        </span>
      )}
    </div>
  );
}
